import Api from './api'

export function checkCouponValidity(coupon: string) {
  return new Promise<any>((resolve, reject) => {
    Api.post('wwwREST', '/v1/public/signup/coupon', { body: { coupon } })
      .then(res => resolve(res))
      .catch(err => reject(err.message))
  })
}
